//import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import OrganizationList from "./";
import { OrgService } from "@/services/organization-service/OrganizationService.ts";
import { IOrgService } from "@/services/organization-service/IOrganizationService.ts";
import { OrganizationInfo } from "@/services/organization-service/entity/OrganizationEntity.ts";

const mapDispatchToProps = () => {
  const orgService: IOrgService = new OrgService();
  return {
    onFetchOrg: async (endpoint: string): Promise<OrganizationInfo[]> => {
      const resp = await orgService.getOrgList(endpoint);
      return resp.data;
    },
  };
};

export default connect(null, mapDispatchToProps)(OrganizationList);
